import { Component, Input, model, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxPopupModule } from 'devextreme-angular';
import { GpdButtonComponent } from '../gpd-button/gpd-button.component';

@Component({
    selector: 'app-project-complete-popup',
    imports: [CommonModule, DxPopupModule, GpdButtonComponent],
    templateUrl: './project-complete-popup.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './project-complete-popup.component.css'
})
export class ProjectCompletePopupComponent {
  visible = model(false);
  @Input() userName: string = '';

  get firstName(): string {
    return this.userName?.split(' ')[0] ?? '';
  }

  close(): void {
    this.visible.set(false);
  }
}
